import { Box, IconButton, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import DeleteIcon from "@mui/icons-material/Delete";
import { SetRowValues } from "../hooks/logic/useProductRegistration";
import { useEffect } from "react";

type Props = {
  id: number;
  values: SetRowValues;
  onChange: (id: number, values: SetRowValues) => void;
  onDelete: (id: number) => void;
  isRegistration?: boolean;
  isDisabled?: boolean;
};

const ProductSetRow = ({
  id,
  values,
  onChange,
  onDelete,
  isRegistration = true,
  isDisabled = false,
}: Props) => {
  const handleChange = (
    key: keyof SetRowValues,
    value: string | Date | null
  ) => {
    onChange(id, { ...values, [key]: value });
  };

  useEffect(() => {
    if (values) {
      handleChange("deliveryCount", values.deliveryCount);
    }
  }, []);

  return (
    <Box display="flex" alignItems="center" gap={1} mb={2} px={2}>
      <TextField
        label="JAN"
        size="small"
        value={values.jan}
        onChange={(e) => handleChange("jan", e.target.value)}
        sx={{ width: "15%" }}
        InputLabelProps={{ sx: { fontSize: "0.9rem" } }}
        disabled={isDisabled}
      />
      <TextField
        label="商品名"
        size="small"
        value={values.name}
        onChange={(e) => handleChange("name", e.target.value)}
        sx={{ width: "30%" }}
        InputLabelProps={{ sx: { fontSize: "0.9rem" } }}
        multiline
        disabled={isDisabled}
      />
      <TextField
        label="セット数"
        size="small"
        value={values.setCount}
        onChange={(e) => {
          const inputValue = e.target.value;
          if (/^\d*$/.test(inputValue)) {
            handleChange("setCount", inputValue);
          }
        }}
        sx={{ width: "10%" }}
        InputLabelProps={{ sx: { fontSize: "0.9rem" } }}
        disabled={isDisabled}
      />
      <TextField
        label="納品数"
        size="small"
        value={values.deliveryCount}
        onChange={(e) => handleChange("deliveryCount", e.target.value)}
        sx={{ width: "10%", backgroundColor: "#a0a0a0" }}
        InputLabelProps={{ sx: { fontSize: "0.9rem" } }}
        disabled
      />
      <TextField
        label="予定入荷総数"
        size="small"
        value={String(Number(values.setCount) * Number(values.deliveryCount))}
        onChange={(e) => handleChange("expectedCount", e.target.value)}
        sx={{ width: "13%", backgroundColor: "#a0a0a0" }}
        InputLabelProps={{ sx: { fontSize: "0.9rem" } }}
        disabled
      />
      {!isRegistration && (
        <>
          <TextField
            label="実出荷単位数"
            size="small"
            value={values.deliveryCount} //{values.shippedCount ?? ""}
            onChange={(e) => handleChange("shippedCount", e.target.value)}
            sx={{ width: "13%", backgroundColor: "#a0a0a0" }}
            InputLabelProps={{ sx: { fontSize: "0.9rem" } }}
            disabled
          />
          <TextField
            label="実入荷総数"
            size="small"
            value={values.receivedCount ?? ""}
            onChange={(e) => handleChange("receivedCount", e.target.value)}
            sx={{ width: "13%" }}
            InputLabelProps={{ sx: { fontSize: "0.9rem" } }}
            disabled={isDisabled}
          />
        </>
      )}
      <DatePicker
        label="賞味期限"
        value={values.expiryDate}
        onChange={(newDate) => handleChange("expiryDate", newDate)}
        minDate={new Date()}
        format="yyyy/MM/dd"
        slotProps={{
          textField: {
            size: "small",
            inputProps: { readOnly: false },
            InputLabelProps: { sx: { fontSize: "0.9rem" } },
          },
        }}
        sx={{ width: "15%" }}
        disabled={isDisabled}
      />
      {/* {!isRegistration && (
        <>
          <TextField
            label={"保管場所"}
            size="small"
            sx={{
              width: "15%",
            }}
            InputLabelProps={{
              sx: {
                fontSize: "0.9rem",
              },
            }}
            value={values.storageLocation}
            onChange={(e) => handleChange("storageLocation", e.target.value)}
          />
        </>
      )} */}
      <IconButton onClick={() => onDelete(id)} disabled={isDisabled}>
        <DeleteIcon />
      </IconButton>
    </Box>
  );
};

export default ProductSetRow;
